<template>
  <section id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="xblock-box">
          <div class="xblock layui-form" :class="{'FloatingNav':SelectedNum > 0}">
            <!-- <button class="layui-btn xblock-row">同步产品<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button> -->
            <button class="layui-btn layui-btn-normal xblock-row" @click="ShowModel('all')">批量编辑<i
                v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button>
            <div class="layui-input-inline xblock-row">
              <input type="text" name="username" placeholder="SKU查询" v-on:keydown.13="ProductList()"
                v-model="sku_parent" autocomplete="off" class="layui-input" />
            </div>
            <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach" v-on:click="ProductList()"><i
                class="fa fa-search"></i></button>
            <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
            <div class="clear-both"></div>
          </div>
        </div>

        <table class="layui-table layui-form" :class="{'FloatingMargin':SelectedNum > 0}">
          <thead>
            <tr>
              <th>
                <input type="checkbox" class="cxall" lay-filter="cxall" name="cxall" lay-skin="primary">
              </th>
              <th>图片</th>
              <th>状态</th>
              <th>站点店铺</th>
              <th>SKU</th>
              <th style="width: 20%;">标题</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody v-viewer v-for="(item,index) in list">
            <tr>
              <td class="cx-box NoSelect" :data-ix="index">
                <div><input type="checkbox" lay-filter="cx" lay-skin="primary" :data-index="index"
                    :checked="item.active"></div>
                <!-- <div class="list-number" v-text="index+1"></div> -->
              </td>
              <td>
                <div class="table_img">
                  <img :src="item.product_detail.item.images[0]">
                </div>
              </td>
              <td>
                <i class="status-box status-box-red" v-if="item.model">已编辑</i>
                <i class="status-box status-box-green" v-else>未编辑</i>
              </td>
              <td v-text="item.country+'-'+item.country_name"></td>
              <td v-text="item.product_detail.item.item_sku"></td>
              <td v-text="item.product_detail.item.name"></td>
              <td class="btn-arr">
                <button class="layui-btn" v-on:click="ViewProducts(index,item.show)">
                  <i v-if="item.show">隐藏价格</i>
                  <i v-else>显示价格</i>
                </button>
                <button class="layui-btn layui-btn-normal" @click="ShowModel(index,item)">编辑价格</button>
              </td>
            </tr>
            <tr v-if="item.show">
              <td colspan="14" style="padding:15px;">
                <table class="layui-table layui-form" style="margin:0;">
                  <thead>
                    <tr>
                      <th>编号</th>
                      <th>SKU</th>
                      <th>商品投入</th>
                      <th>其它投入</th>
                      <th>总投入</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="val in item.sku_list">
                      <td v-text="val.model_id"></td>
                      <td v-text="val.model_sku"></td>
                      <td v-text="val.price"></td>
                      <td v-text="val.other_price"></td>
                      <td v-text="val.total"></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

        <!--scroll to top-->
        <div class="scroll-top">
          <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>

      </div>

      <!-- 分页 -->
      <div class="page-box">
        <div id="pagebox" class="pagebox"></div>
      </div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage, isRefresh, modalbox, list_datas, obj_arr;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition
    },
    data() {
      return {
        SelectedNum: 0,
        isLoding: true,
        id: null,
        ix: 0,
        sku_parent: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        isloding: false,
        list: [],
        shops: [],
        navlist: [{
          id: 0,
          count: 0,
          active: false,
          name: "全部",
        }, {
          id: 1,
          count: 0,
          active: false,
          name: "未发布",
        }, {
          id: 2,
          count: 0,
          active: false,
          name: "已发布",
        }],
        merchants: [],
      }
    },
    updated() {
      if (form) {
        form.render();
      }
      self.NumberCheck();
    },
    mounted() {
      self = this;
      self.SetNavActive("管理", self.$route.name);
      scrollTop(); //监听滚动置顶

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        self.get_shop_list();
        self.VersionCheck(); //版本检测

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          var num = 0;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
            if (status) {
              num++
            }
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

      });

      $(".layui-body").scroll(function() {
        let scrollTop = $(this).scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      })

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      VersionCheck() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if (json.code == 200) {
            if (json.datas.version != localStorage.getItem("ExShopee_Version")) {
              localStorage.setItem("ExShopee_Version", json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      ShowModel(ix, item) {
        self.ix = ix;
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 195;
        };
        modalbox = layer.open({
          type: 1,
          offset: '100px',
          title: "编辑商品",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['提交'],
          content: EditProduct,
          success: function() {

            list_datas = [], obj_arr = [];
            if (ix == "all") {
              for (let j in self.list) {
                if (self.list[j].active) {
                  obj_arr.push({
                    item_id: self.list[j].item_id,
                    model: []
                  });

                  for (let z in self.list[j].sku_list) {
                    self.list[j].sku_list[z].item_id = self.list[j].item_id;
                    list_datas.push(self.list[j].sku_list[z]);
                  }
                }
              }
            } else {
              list_datas = item.sku_list;
            }

            var xhtml = "";
            for (let i in list_datas) {
              xhtml += '<tr class="layui-form">'
              xhtml += "<td>" + list_datas[i].item_id + "</td>"
              xhtml += "<td class='model_id'>" + list_datas[i].model_id + "</td>"
              xhtml += "<td>" + list_datas[i].model_sku + "</td>"
              xhtml += '<td>'
              if (list_datas[i].price) {
                xhtml += '<input class="layui-input price" value="' + list_datas[i].price + '" />'
              } else {
                xhtml += '<input class="layui-input price" />'
              }
              xhtml += '</td>'
              xhtml += '<td>'
              if (list_datas[i].other_price) {
                xhtml += '<input class="layui-input other_price" value="' + list_datas[i].other_price + '" />'
              } else {
                xhtml += '<input class="layui-input other_price" />'
              }
              xhtml += '</td>'
              xhtml += "</tr>"
            }
            $("#table-html").append(xhtml);


            form.on('submit(allApply)', function(data) {
              let price = $(".all_price").val();
              let other_price = $(".all_other_price").val();
              $("#table-html tr").each(function() {
                $(this).find(".price").val(price);
                $(this).find(".other_price").val(other_price);
              });
            });
            form.render();
          },
          yes: function(index, layero) {
            var arr = [];
            $("#table-html tr").each(function() {
              let id = $(this).find(".model_id").text();
              let price = $(this).find(".price").val();
              let other_price = $(this).find(".other_price").val();


              if (self.ix == "all") {
                for (let x in list_datas) {
                  if (list_datas[x].model_id == id) {
                    list_datas[x].price = price;
                    list_datas[x].other_price = other_price;
                  }
                }
              } else {
                for (let i in self.list[ix].sku_list) {
                  if (self.list[ix].sku_list[i].model_id == id) {
                    self.list[ix].sku_list[i].price = price;
                    self.list[ix].sku_list[i].other_price = other_price;
                  }
                }
              }
            });
            let param = new URLSearchParams()
            if (self.ix == "all") {
              for (let z in list_datas) {
                for (let l in obj_arr) {
                  if (list_datas[z].item_id == obj_arr[l].item_id) {
                    obj_arr[l].model.push(list_datas[z]);
                  }
                }
              }
              param.append('datas', JSON.stringify(obj_arr));
            } else {
              let item_id = self.list[ix].item_id;
              let models = self.list[ix].sku_list;
              param.append('datas', JSON.stringify([{
                item_id: item_id,
                model: models
              }]))
            }

            axios({
              method: 'post',
              url: self.GetServerUrl() + "/item_money_update/",
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              },
              data: param,
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                layer.msg("修改成功！");
                layer.close(modalbox);
                self.ProductList();
              });

            }).catch(function(error) {
              self.ToastFun(2, error); //弹窗提醒
            })

          }
        });
      },
      get_shop_list() {
        let param = new URLSearchParams()
        param.append('num', 999)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_list/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              self.shops = datalist;
              self.ProductList();
            }
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      ProductList() {
        let param = new URLSearchParams()
        param.append('type', self.ix)
        if (self.sku_parent) {
          self.page = 1;
          param.append('sku', self.sku_parent)
        }
        param.append('num', self.page_num)
        param.append('page', self.page)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + '/user_items/?page=' + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              for (let i in list) {
                list[i].show = false;
                list[i].active = false;
                list[i].item_detail = JSON.parse(list[i].item_detail);
                list[i].product_detail = JSON.parse(list[i].product_detail);

                //SKU列表
                if (list[i].model) {
                  list[i].sku_list = JSON.parse(list[i].model);
                } else {
                  if (list[i].item_detail.model && list[i].item_detail.model.length > 0) {
                    list[i].sku_list = list[i].item_detail.model;
                  } else {
                    if (list[i].product_detail.item) {
                      let item = list[i].product_detail.item;
                      list[i].sku_list = [{
                        item_id: item.item_id,
                        model_id: item.item_id,
                        model_sku: item.item_sku
                      }];
                    } else {
                      let item = list[i].product_detail;
                      list[i].sku_list = [{
                        item_id: item.item_id,
                        model_id: item.item_id,
                        model_sku: item.item_sku
                      }];
                    }
                  }
                }

                //新版兼容
                if (!list[i].product_detail.item) {
                  list[i].product_detail.item = {
                    images: null,
                    name: null,
                    item_sku: null
                  }
                  list[i].product_detail.item.images = list[i].product_detail.image.image_url_list;
                  list[i].product_detail.item.name = list[i].product_detail.item_name;
                  list[i].product_detail.item.item_sku = list[i].product_detail.item_sku;
                }


                // console.log(list[i].sku_list)
                for (let j in list[i].sku_list) {
                  list[i].sku_list[j].item_id = list[i].item_id;
                  if (list[i].sku_list[j].price) {
                    list[i].sku_list[j].total = parseFloat(list[i].sku_list[j].price);
                  }
                  if (list[i].sku_list[j].other_price) {
                    list[i].sku_list[j].total += parseFloat(list[i].sku_list[j].other_price);
                  }
                }

                for (let j in self.shops) {
                  if (list[i].shop_id == self.shops[j].id) {
                    for (let z in country) {
                      if (country[z].en_name == self.shops[j].country) {
                        list[i].exchange = country[z].exchange;
                      }
                    }
                    list[i].expend = 10;
                    list[i].country = self.shops[j].country;
                    list[i].country_name = self.shops[j].name;
                  }
                }

              }

              self.list = list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();
              // console.log(list);
            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      UpdateProduct(item) {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('datas', JSON.stringify(datas));
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/static_order_money/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.ToastFun(0, "信息同步成功！"); //弹窗提醒
            self.ProductList();
          });

        }).catch(function(error) {
          console.log(error);
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      NumberCheck() {
        let num = 0;
        for (let i in self.list) {
          if (self.list[i].active) {
            num++
          }
        }
        self.SelectedNum = num;
        let scrollTop = $(".layui-body").scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      },
      ViewProducts(ix, state) {
        if (state) {
          self.list[ix].show = false;
        } else {
          self.list[ix].show = true;
        }
        self.$forceUpdate();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .redtxt,
  .greenColor {
    font-weight: bold;
  }

  .cx-box {
    width: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/Product.vue